import { useQuery } from '@tanstack/react-query';
import { functions } from '../../firebase';
import { normalizeMonitoringOverview } from './helpers';
import { MonitoringOverview } from './types';

export async function fetchMonitoringOverview(): Promise<MonitoringOverview> {
  const response = await functions.httpsCallable('settings')({
    requestType: 'GET_MONITORING_OVERVIEW',
  });
  const data = response?.data;
  const errorCode = data?.httpErrorCode?.status;
  if (errorCode && errorCode !== 200) {
    throw new Error(`Settings API error: ${errorCode}`);
  }
  if (
    !data ||
    !data.summary ||
    !Array.isArray(data.devices) ||
    !Array.isArray(data.incidents) ||
    !data.filters ||
    !Array.isArray(data.filters.deviceFamilies) ||
    !Array.isArray(data.filters.severities) ||
    !Array.isArray(data.filters.ruleCodes) ||
    !Array.isArray(data.filters.incidentStates)
  ) {
    throw new Error('Ugyldigt svar fra overvågningen. Prøv igen.');
  }
  return normalizeMonitoringOverview(data);
}

export function useMonitoringOverview(enabled = true) {
  return useQuery({
    queryKey: ['monitoring-overview'],
    queryFn: fetchMonitoringOverview,
    enabled,
    refetchInterval: 60_000,
    staleTime: 60_000,
  });
}

export default useMonitoringOverview;
